import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-audit',
  templateUrl: './content-audit.component.html',
  styleUrls: ['./content-audit.component.css']
})
export class ContentAuditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
